import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import _ = require('underscore');
import { NotificationService } from '../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../app.common/modules/common/services/popup.service';
import { RetailerService } from '../api/retailer.service';
import { ServicesService } from '../common/services/services.service';
import { IPagingResult } from '../model/IPagingResult.model';
import { IServiceFetchFilter, IServiceModelListItem } from '../model/services/IServicesModel';

export class ServicesTabs {

    public static $inject = [
        '$uibModal',
        '$state',
        '$translate',
        'notificationService',
        'popupService',
        'servicesService',
        '$localStorage',
        'retailerService'
    ];

    public search = {
        placeholder: '' as string,
        text: '' as string
    };

    public waiting: boolean = false;
    public canLoadMore: boolean = true;
    public services: IServiceModelListItem[] = [];
    public total: number = 0;
    public forSearch: boolean = false;
    public searchMessageContent: string = '';
    public itemsLimit: number = 20;
    public isActive: boolean = true;
    public countryID: number;

    constructor(
        public $uibModal: ng.ui.bootstrap.IModalService,
        public $state: StateService,
        public $translate: angular.translate.ITranslateService,
        public notificationService: NotificationService,
        public popupService: PopupService,
        public servicesService: ServicesService,
        private $localStorage: ngStorage.StorageService,
        private retailerService: RetailerService
    ) {
        this.isActive = $state.params.isActive;
    }

    public async $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
        this.loadData(false);
    }

    public async deleteService(service: IServiceModelListItem) {
        try {
            const result = await this.popupService.confirm({
                title: this.$translate.instant('archive_service_title'),
                cancelClass: 'btn btn-with-icon btn-in-popup-footer w102',
                content: `<span>${this.$translate.instant('archive_service_message', {name: service.Title})}</span>`, // {serviceTitle: service.Title}
                okClass: 'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent w106',
                classPopup: 'popup--redesign modal360',
                cancelTxt: this.$translate.instant('cancel'),
                okTxt: this.$translate.instant('button_archive'),
                hasIcon: true
            });
            try {
                await this.servicesService.archiveService(service.ID);
            } catch (error) {
                this.notificationService.showErrorMessage();
            }
            this.resetList();
            this.loadData(false);

        } catch (error) {
            this.waiting = false;
            return;
        }
    }

    public async onEdit(service: IServiceModelListItem) {
        this.$state.go('app.editService', {id: service.ID});
    }

    public async restoreService(service: IServiceModelListItem) {
        try {
            const result = await this.popupService.confirm({
                title: this.$translate.instant('service_restore_title'),
                content: `<span>${this.$translate.instant('restore_service_message', {name: service.Title})}</span>`,
                cancelClass: 'btn btn-with-icon btn-in-popup-footer w102',
                okClass: 'btn btn-with-icon btn-with-icon--before-restore btn-success flexVerticalAlignParent w107',
                classPopup: 'popup--redesign modal360',
                cancelTxt: this.$translate.instant('cancel'),
                okTxt: this.$translate.instant('restore'),
                hasIcon: true
            });
            try {
                await this.servicesService.restoreService(service.ID);
            } catch (error) {
                this.notificationService.showErrorMessage();
            }
            this.resetList();
            this.loadData(false);
        } catch (error) {
            this.waiting = false;
            return;
        } finally {
            this.notificationService.clearAll();
        }
    }

    public loadData(forSearch: boolean) {
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.waiting = true;

        const filter: IServiceFetchFilter = {
            IsArchive: !this.isActive,
            Limit: this.itemsLimit,
            SortColumn: 'name',
            SortOrder: 0,
            SearchAfterID: this.services.length ? _.last(this.services).ID : null,
            keyword: forSearch ? this.search.text : null
        };

        this.notificationService.showWaitingMessage();

        this.servicesService.getServices(filter)
            .then((result: IPagingResult<IServiceModelListItem>) => {

                    this.forSearch = forSearch;

                    this.total = result.Total;
                    const services: IServiceModelListItem[] = result.Items;

                    Array.prototype.push.apply(this.services, services);
                    this.waiting = false;
                    this.canLoadMore = result.Items.length === this.itemsLimit;

                    if (this.services.length > 0) {
                        return;
                    }

                    if (this.search.text && forSearch) {
                        this.searchMessageContent = this.$translate.instant('services_list_not_found_screen_content', {search: this.search.text});
                    }
                    this.notificationService.clearAll();
                }
            )
            .catch((error) => this.notificationService.showErrorMessage(error))
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

    public setTab(isActive: boolean) {
        this.isActive = isActive;
        this.resetList();
        this.resetSearch();

        if (this.isActive) {
            this.$state.go('app.activeServices', {isActive: true});
        } else {
            this.$state.go('app.archivedServices', {isActive: false});
        }
    }

    public async resetSearch() {
        this.search.text = '';
        this.applySearch('');
    }

    public applySearch(searchText: string) {
        this.search.text = searchText;
        this.resetList();
        this.loadData(searchText.length > 0);
    }

    public getPriceTypeText(priceType: number): string {
        if (priceType === 0) {
            return this.$translate.instant('services_fixed');
        } else {
            return this.$translate.instant('services_editable');
        }
    }

    public getImageUrl(service: IServiceModelListItem): string {
        return this.retailerService.serviceImage(service.ImageID, 48, 48);
    }

    private resetList() {
        this.canLoadMore = true;
        this.total = 0;
        this.services = [];
    }

}

angular.module('naut').component('servicesTabs', {
    template: require('./services-tabs.component.html'),
    controller: ServicesTabs,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/services/services-tab.component.ts